export const imports = {};
import * as react from 'react';
import * as components from '/home/runner/work/react-showroom/react-showroom/examples/react-example/src/components/index.ts';
imports.react = react;
imports.components = components;
